import { ChatSendMessageToastContext } from '@/components/chat/ChatSendMessageToast/ChatSendMessageToastProvider'
import { ButtonComponent } from '@/components/commons'
import { IUser } from '@/interfaces/user'
import { cssClass } from '@/shared/utils'
import {
  useIsOwnProfile,
  useProfile,
} from 'containers/profile/hooks/useProfile'
import { buttonsVariationMaxWidth } from 'containers/profile/styles/buttons.css'
import { User } from 'containers/user/types/user'
import { useContext } from 'react'

interface MessageButtonProps {
  profile?: User
  disabled?: boolean
  loading?: boolean
  buttonClassName?: string
  customSize?: { padding: number }
}

export const MessageButton = ({
  profile,
  disabled,
  loading,
  buttonClassName,
  customSize,
}: MessageButtonProps) => {
  const { profile: currentProfile } = useProfile()
  const { showToast } = useContext(ChatSendMessageToastContext)
  const profileUsing = profile || currentProfile
  const ownProfile = useIsOwnProfile(profileUsing)

  const handleSendMessage = () => {
    if (profileUsing?.id) {
      showToast([profileUsing as IUser])
    }
  }

  if (ownProfile) return null

  return (
    <ButtonComponent
      size="xSmall"
      variation={
        profile && profile?.id !== currentProfile?.id ? 'primary' : 'secondary'
      }
      className={cssClass([
        buttonClassName ? buttonClassName : buttonsVariationMaxWidth[130],
      ])}
      fullWidth
      label={'Message'}
      customSize={customSize ? customSize : { padding: 35 }}
      disabled={disabled}
      loading={loading}
      onClick={handleSendMessage}
    />
  )
}
